import React from 'react';
import Schendule from './components/Schendule';

function App() {
  return (
    <Schendule />
  );
}

export default App;
